import customAxios from "../../customAxios";
import { REMOVE_IS_APPROVE_PARENT } from "../../routes";

const removeIsAproveParent = async (_id: string) => {
  var thisUrl = REMOVE_IS_APPROVE_PARENT + "/" + _id;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ ADMIN_ALL_SERVICE: error });
  }
};

export default removeIsAproveParent;
